import { ShowDrafts, ShowEpisodes } from 'resources';
import prependToCollection from 'app/collection/actions/prepend';
import removeFromCollection from 'app/collection/actions/remove';

export default episode => {
  removeFromCollection(ShowDrafts, episode.show, [episode]);
  prependToCollection(ShowEpisodes, episode.show, [episode]);
};
